import { actionTypes } from '../constants';

const createInitialState = () => ({
  search: '',
});

export const reducer = (state = createInitialState(), { type, payload }) => {
  switch (type) {
    case actionTypes.currentCompanyChanged:
    case actionTypes.currentCityChanged:
    case actionTypes.createReset: {
      return createInitialState();
    }

    case actionTypes.relatedRoomsSearchChanged: {
      return { ...state, search: payload };
    }

    default:
      return state;
  }
};
